{
  "tenant": "{{tenant}} French",
  "image": "assets/tenant-assets/images/home/hom-banner-image.webp",
  "APP_TITLE": "WOW fr"
}
